export const getInfosGraphAosCount=(inputArray,filtreClient,selectedClient,clientName)=> {
    const dataMap = new Map();
    const dateSet = new Set();

    for (const item of inputArray) {
        const { companyDataId, dateDebutAO } = item;
        const monthYear = dateDebutAO.substring(0, 7);
        dateSet.add(monthYear);

        if (!dataMap.has(companyDataId)) {
            dataMap.set(companyDataId, []);
        }

        const monthIndex = Array.from(dateSet).indexOf(monthYear);
        if (!dataMap.get(companyDataId)[monthIndex]) {
            dataMap.get(companyDataId)[monthIndex] = 1;
        } else {
            dataMap.get(companyDataId)[monthIndex]++;
        }
    }

    const dates = Array.from(dateSet).sort();
    const data = Array.from(dataMap, ([name, data]) => ({ name, data }));

    if(filtreClient){
        data.forEach((key) => {
            const tempClient=selectedClient.find((item) => item._id === key.name);
            if(tempClient)
                key.name=tempClient.label;
            else
                key.name=null;
        });
    }
    else{
        data.forEach((key) => {
            key.name=clientName;
        });

    }
    return {dates,data};
};

export const listStautAO = [
    {label:'Ouvert',value:'open'},
    {label:'Clôturé',value:'close'},
    {label:'Tout',value:'all'}
];

export const typeFactureList = [
    {
        label:'Normal',
        value:'normal',

    },
    {
        label:'PC',
        value:'PC'
    },
    {label:'Tout',value:'all'}
];

export const statutPaiement = [
    {
        label:'Payé',
        value:'paye',

    },
    {
        label:'Non payé',
        value:'nonPaye'
    },
    {label:'Tout',value:'all'}
];